<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="slot_list"
      :loading="table_loading"
      loading-text="Loading... Please wait"
      :mobile-breakpoint="0"
      hide-default-footer
      :items-per-page="120"
    >
      <template
        v-slot:[`item.motor_number`]="props"
        v-if="machine_type == 'Nubox_v2'"
      >
        <div>
          <v-text-field
            v-model="props.item.motor_number"
            single-line
            placeholder="Motor Number"
            @keypress="only_for_number"
            dense
            flat
            solo
            hide-details="auto"
            :rules="[
              () => !!props.item.motor_number || 'Can\'t be empty',
              () => is_numeric(props.item.motor_number) || 'Invalid number',
              () => Number(props.item.motor_number) > 0 || 'Can\'t be zero',
              () =>
                check_duplicated_motor_number(
                  props.item.motor_number,
                  slot_list.findIndex(
                    (x) => x.slot_label == props.item.slot_label
                  )
                ) || 'Duplicated',
            ]"
          ></v-text-field>
        </div>
      </template>
      <template
        v-slot:[`item.slot_label`]="props"
        v-if="machine_type == 'China'"
      >
        <div>
          <v-text-field
            v-model="props.item.slot_label"
            single-line
            placeholder="Slot Label"
            @keypress="only_for_number"
            dense
            flat
            solo
            hide-details="auto"
            :rules="[
              () => !!props.item.slot_label || 'Can\'t be empty',
              () => is_numeric(props.item.slot_label) || 'Invalid number',
              () => Number(props.item.slot_label) > 0 || 'Can\'t be zero',
              () =>
                check_duplicated_slot_label(
                  props.item.slot_label,
                  slot_list.findIndex(
                    (x) => x.motor_number == props.item.motor_number
                  )
                ) || 'Duplicated',
            ]"
          ></v-text-field>
        </div>
      </template>
      <template v-slot:[`item.product_sku`]="props">
        <div>
          <v-text-field
            v-model="props.item.product_sku"
            single-line
            placeholder="Product SKU"
            dense
            flat
            solo
            hide-details="auto"
            :rules="[() => !!props.item.product_sku || 'Can\'t be empty']"
          ></v-text-field>
        </div>
      </template>
      <template v-slot:[`item.product_name`]="props">
        <div>
          <v-text-field
            v-model="props.item.product_name"
            single-line
            placeholder="Product Name"
            dense
            flat
            solo
            hide-details="auto"
            :rules="[() => !!props.item.product_name || 'Can\'t be empty']"
          ></v-text-field>
        </div>
      </template>
      <template v-slot:[`item.product_image`]="props">
        <div @click="upload_product_image(props.item.motor_number)">
          <input
            :key="componentKey"
            @change="product_image_selected"
            ref="product_image_upload"
            type="file"
            accept="image/*"
            hidden
          />
          <div v-if="props.item.product_image == 'Loading'">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
          <div v-else-if="props.item.product_image != ''">
            <img
              width="60"
              height="60"
              :src="props.item.product_image"
              alt="image"
            />
            <!-- <v-lazy-image
              width="60"
              height="60"
              :src="props.item.product_image"
            /> -->
          </div>
          <div v-else>
            <p style="margin-bottom: 0">No Image</p>
          </div>
        </div>
      </template>
      <template v-slot:[`item.product_description_image`]="props">
        <div @click="upload_product_description_image(props.item.motor_number)">
          <input
            :key="componentKey"
            @change="product_description_image_selected"
            ref="product_description_image_upload"
            type="file"
            accept="image/*"
            hidden
          />
          <div v-if="props.item.product_description_image == 'Loading'">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
          <div v-else-if="props.item.product_description_image != ''">
            <img
              width="60"
              height="60"
              :src="props.item.product_description_image"
              alt="image"
            />
          </div>
          <div v-else>
            <p style="margin-bottom: 0">No Image</p>
          </div>
        </div>
      </template>
      <template v-slot:[`item.selling_price`]="props">
        <div>
          <v-currency-field
            v-model="props.item.selling_price"
            single-line
            placeholder="Selling Price"
            dense
            flat
            solo
            hide-details="auto"
          ></v-currency-field>
        </div>
      </template>
      <template v-slot:[`item.second_selling_price`]="props">
        <div>
          <v-currency-field
            v-model="props.item.second_selling_price"
            single-line
            placeholder="2nd Price"
            dense
            flat
            solo
            hide-details="auto"
          ></v-currency-field>
        </div>
      </template>
      <template v-slot:[`item.third_selling_price`]="props">
        <div>
          <v-currency-field
            v-model="props.item.third_selling_price"
            single-line
            placeholder="3rd Price"
            dense
            flat
            solo
            hide-details="auto"
          ></v-currency-field>
        </div>
      </template>
      <template v-slot:[`item.fourth_selling_price`]="props">
        <div>
          <v-currency-field
            v-model="props.item.fourth_selling_price"
            single-line
            placeholder="4th Price"
            dense
            flat
            solo
            hide-details="auto"
          ></v-currency-field>
        </div>
      </template>
      <template v-slot:[`item.fifth_selling_price`]="props">
        <div>
          <v-currency-field
            v-model="props.item.fifth_selling_price"
            single-line
            placeholder="5th Price"
            dense
            flat
            solo
            hide-details="auto"
          ></v-currency-field>
        </div>
      </template>
      <template v-slot:[`item.sixth_selling_price`]="props">
        <div>
          <v-currency-field
            v-model="props.item.sixth_selling_price"
            single-line
            placeholder="6th Price"
            dense
            flat
            solo
            hide-details="auto"
          ></v-currency-field>
        </div>
      </template>
      <template v-slot:[`item.cost_price`]="props">
        <div>
          <v-currency-field
            v-model="props.item.cost_price"
            single-line
            placeholder="Cost Price"
            dense
            flat
            solo
            hide-details="auto"
          ></v-currency-field>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
// import VLazyImage from "v-lazy-image/v2";
export default {
  // components: {
  //   VLazyImage,
  // },
  props: {
    headers: Array,
    slot_list: Array,
    table_loading: Boolean,
    is_validated: Boolean,
    machine_type: String,
    componentKey: Number,
  },
  data: function () {
    return {
      selected_motor_number: -1,
    };
  },
  methods: {
    check_duplicated_slot_label(slot_label, slot_index) {
      var is_used = false;
      for (var i = 0; i < this.slot_list.length; i++) {
        if (i != slot_index) {
          if (slot_label == this.slot_list[i]["slot_label"]) {
            is_used = true;
          }
        }
      }
      return !is_used;
    },
    check_duplicated_motor_number(motor_number, slot_index) {
      var is_used = false;
      for (var i = 0; i < this.slot_list.length; i++) {
        if (i != slot_index) {
          if (motor_number == this.slot_list[i]["motor_number"]) {
            is_used = true;
          }
        }
      }
      return !is_used;
    },
    upload_product_description_image(motor_number) {
      if (this.$refs.product_description_image_upload instanceof HTMLElement) {
        this.$refs.product_description_image_upload.click();
      }
      this.selected_motor_number = motor_number;
      this.$emit("product_description_image_clicked", motor_number);
    },
    upload_product_image(motor_number) {
      if (this.$refs.product_image_upload instanceof HTMLElement) {
        this.$refs.product_image_upload.click();
      }
      this.selected_motor_number = motor_number;
      this.$emit("product_image_clicked", motor_number);
    },
    product_description_image_selected(e) {
      if (typeof e.target.files[0] != "undefined") {
        var index = this.slot_list.findIndex(
          (x) => x["motor_number"] == this.selected_motor_number
        );
        if (index > -1) {
          this.$emit("image_description_uploading");
          var file = e.target.files[0];

          var form_data = new FormData();
          form_data.append("image", file);
          this.upload_image("uploadProfileImage", form_data)
            .then((response) => {
              if (response.data.status == "OK") {
                this.$emit(
                  "image_description_selected_success",
                  response.data.url
                );
              } else {
                this.$emit("image_description_selected_error");
              }
              this.selected_motor_number = -1;
            })
            .catch((error) => {
              this.selected_motor_number = -1;
              this.$emit("image_description_selected_error");
            });
        } else {
          this.$emit("image_description_selection_cancelled");
        }
      } else {
        this.$emit("image_description_selection_cancelled");
      }
    },
    product_image_selected(e) {
      if (typeof e.target.files[0] != "undefined") {
        var index = this.slot_list.findIndex(
          (x) => x["motor_number"] == this.selected_motor_number
        );
        if (index > -1) {
          this.$emit("image_uploading");
          var file = e.target.files[0];

          var form_data = new FormData();
          form_data.append("image", file);
          this.upload_image("uploadProfileImage", form_data)
            .then((response) => {
              if (response.data.status == "OK") {
                this.$emit("image_selected_success", response.data.url);
              } else {
                this.$emit("image_selected_error");
              }
              this.selected_motor_number = -1;
            })
            .catch((error) => {
              this.selected_motor_number = -1;
              this.$emit("image_selected_error");
            });
        } else {
          this.$emit("image_selection_cancelled");
        }
      } else {
        this.$emit("image_selection_cancelled");
      }
    },
  },
};
</script>

<style scoped>
.validate {
  /* background-color: #ffebee; */
  background-color: black;
}
</style>